<template>
  <img :src="src" class="jko" alt="街口支付" />
</template>

<script setup lang="ts">
import src from '@/assets/logos/jko-pay.png'
</script>

<style scoped>
.jko {
  display: block;
  height: 44px;
  width: auto;
  object-fit: contain;
}
</style>
